import axios from 'axios';
import { CLIENT } from "./constants";

const apiClient = axios.create({ baseURL: CLIENT.baseUrl });

const fetchDecorationTypes = () => apiClient.get('v1/decorations/types');

const fetchDecorationPortraits = () => apiClient.get('v1/decorations/portraits');

const fetchDecorations = (searchCode, page) => apiClient.get(`v1/decorations/search?searchCode=${searchCode}&page=${page}`);

const fetchBookingData = () => apiClient.get('/booking/data')

const doLogin = (credentials) => apiClient.get(`/login?user=${credentials.user}&password=${credentials.password}`);

const postDecoration = (formBody) => apiClient.post(`v1/decoration/post`, formBody)

export {
    fetchDecorationTypes,
    fetchDecorationPortraits,
    fetchDecorations,
    fetchBookingData,
    doLogin,
    postDecoration
}